import { isActiveObligation } from './term';

import type { Obligation } from '@avalara/types/ztb';

// NOTE: These are products that might show up as AvaTax per criteria, but they shouldn't be considered AvaTax
const NON_AVATAX_PRODUCTS = ['AvaTax for Communications', 'Avalara Extractor for RSB'];

const isNotAvaTax = (itemName: string): boolean =>
  itemName ? NON_AVATAX_PRODUCTS.some((product) => itemName.includes(product)) : false;

export const isAvataxObligation = ({ itemName, productCategory, productCatalogId }: Obligation): boolean =>
  (productCategory === 'AvaTax' ||
    productCatalogId === 'CALC_AVTX_SVC' ||
    Boolean(itemName?.includes('AvaTax')) ||
    Boolean(itemName?.includes('Extractor'))) &&
  !isNotAvaTax(itemName);

// NOTE: One of the BigCommerce ESB IPS obligations has a productSubCategory as "FreeTrial" so excluding it
// It was not considered free trial in the OPUS obligations check
export const isTrialAvataxObligation = (obligation: Obligation): boolean =>
  isAvataxObligation(obligation) &&
  obligation.productSubCategory === 'FreeTrial' &&
  !obligation.itemName.includes('BigCommerce ESB');

export const isPaidAvataxObligation = (obligation: Obligation): boolean =>
  isAvataxObligation(obligation) && obligation.productSubCategory !== 'FreeTrial';

export const isSandboxObligation = ({ isAvaTaxSandbox }: Obligation): boolean => isAvaTaxSandbox === true;

export const getHighestActiveAvataxTier = (obligations: Array<Obligation>): number =>
  Math.max(
    0,
    ...obligations
      .filter(isActiveObligation)
      .filter(isAvataxObligation)
      .map(({ quantity }) => quantity || 0),
  );

export const isAvalaraIncludedCustomer = (obligations: Array<Obligation>): boolean =>
  obligations.some(({ isAvalaraIncluded }) => isAvalaraIncluded === true);
